import React from 'react';
import ReactDOMServer from 'react-dom/server';
import Tooltip from 'components/Tooltip';

export default ReactDOMServer.renderToStaticMarkup(
  <div className="drop-files table m-xs-b-0">

      <div className="drop-progress" style={{display: 'none'}}>
        <progress className="progress progress-info progress" value="0" max="100">0%</progress>
      </div>

      <div className="drop-preview m-xs-b-sm">
        <img data-dz-thumbnail={true} role="presentation" className="file-source" />
      </div>

      <div className="drop-metadata word-wrap">
        <p className="m-xs-b-0">
          <span className="drop-name block m-xs-b-xs" data-dz-name={true}></span>
          <span className="drop-size text-muted block" data-dz-size={true}>
</span>
        </p>
        <strong className="error text-danger" data-dz-errormessage={true}></strong>
      </div>

      <div className="drop-remove-file">
        <div className="wrapper-file-remove-popover">
          <Tooltip className="file-remove-popover" content="Delete file" icon="ficon-trash" forceVisibility={false} />
        </div>
        <button data-dz-remove={true} type="button" className="file-remove bg-gray-lightest close close-dangle show" aria-hidden="true">
          <i className="ficon ficon-trash" title="Remove file"></i>
        </button>
      </div>

  </div>
);



// WEBPACK FOOTER //
// ./app/javascript/components/DropzonePreviewTemplate.js